import { avisoLocal } from "../../../appMovil/appMovil";
import { useSaltoACita } from "./saltoACita";
import { useFotos } from "../../../appMovil/fotos";
import { ponerWappteam, useContadores } from "../../../appMovil/contadores";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { RootState } from "../../../globals";
import HttpManager from "../../../services/HttpManager";
import { EquipoCanal, EquipoCanalInfo, EquipoMensaje, Sticker } from "../../../services/v2/prospects.service";
import { BotonLlamar, BurbujaLlamada, LlamadaViva, esMensajeLlamada } from "./llamadasEquipo";
import { useArrastre } from "./arrastre";
import WappIcono from "../../../components/wappIcono";
import { barraAbajo, EMOJIS, esMedio, Texto, vistoCambiaAlgo } from "./equipoView";
import { BotonGif, resumenTexto } from "./equipoGifs";
import EquipoReenviar from "./equipoReenviar";
import { BotonEmoji, EmojisFlotante, insertarEnCursor, teclaEnter } from "./equipoEmojis";
import { Album, agruparAlbumes, BandejaEnvio, Elegido, elegidosDe, enviarVarios, estadoPalomitas, MAX_ARCHIVOS, MedioMensaje, Palomitas, PastillaReacciones, useArchivosEntrantes } from "./equipoMedios";
import { cuando, diaClave, diaEtiqueta, errorTexto, hora } from "./salesHelpers";
import { intervaloRespaldo, push } from "./push";
import { equipoVista, pedirPermisoAvisos, permisoAvisos, prefs, sonar } from "./equipoAvisos";
import "./wappteamDock.css";
import { useCrecer } from "./crecer";
import { idsMencionados, ListaMenciones, Persona, primerNombre, useMenciones } from "./menciones";
import { BarraSeleccion } from "./seleccion";
import { IconoCanal } from "./iconoCanalPicker";
import { BuscadorChat, ItemBusqueda } from "./buscarMensajes";
import { useBorrador } from "./borradores";
import { Reloj, useEnCamino } from "./equipoEnCamino";

/**
 * Ventanitas de WappTeam en toda la app (Esteban, 2026-10-09, reemplazo de Cliq): una barrita abajo a la derecha con
 * las conversaciones recientes y los no leídos; cada conversación se abre en una ventanita para leer y contestar sin
 * salir de la pantalla (hasta 3 en computadora, 1 a pantalla completa en el celular), se minimiza o se cierra, y las
 * abiertas se recuerdan en esta computadora. Avisos: en pantalla (tarjetita), del navegador si la pestaña no está al
 * frente, y un sonido corto; respeta "No molestar" y las conversaciones silenciadas (salvo menciones).
 * Se monta una vez en app.tsx; en /wappteam no se dibuja (ya está la pantalla completa) pero los avisos siguen.
 */
interface Ventana { id: number; min: boolean; }
/** ia: aviso de IA Washington, se queda hasta cerrarlo o abrirlo (Esteban, 2026-10-10); los demás se van solos a los 7 s. */
interface Toast { key: number; canalId: number; titulo: string; texto: string; mencion: boolean; ia?: boolean; }
/** Avisos en pantalla a la vista a la vez; los demás salen como "y N más". */

const MAX_TOASTS = 3;
const MAX_IA_GUARDADOS = 30;

const ANCHO_BARRA = 260;
const ANCHO_VENTANA = 300;
const HUECO = 10;
const MOVIL = 700;

const inicialesDe = (nombre: string): string => nombre.split(/\s+/).filter(Boolean).slice(0, 2).map((x) => x[0]).join("").toUpperCase() || "?";
const tono = (id: number) => "tono-" + (Math.abs(id) % 6);
const previa = (c: EquipoCanal): string => {
	if (!c.ultimo) return c.descripcion || "Sin mensajes";
	const [autor, ftipo, txt] = c.ultimo.split("|");
	return (autor && c.tipo !== "directo" ? autor.split(" ")[0] + ": " : "") + (resumenTexto(txt) || (ftipo === "audio" ? "Nota de voz" : ftipo === "image" ? "Foto" : ftipo === "video" ? "Video" : ftipo === "sticker" ? "Sticker" : ftipo ? "Archivo" : "Cliente compartido"));
};

const Avatar: React.FC<{ c: { id: number; tipo: string; nombre: string; anuncios?: boolean; otro_id?: number | null; icono?: string | null } }> = ({ c }) => {
	const fotos = useFotos();
	const foto = c.otro_id ? fotos[c.otro_id] : null;
	const emoji = c.tipo !== "directo" && c.icono ? c.icono : null;
	return (
		<span className={"wtd-av " + (c.tipo === "canal" ? "canal" : c.tipo === "grupo" ? "grupo" : tono(c.id)) + (foto ? " con-foto" : "") + (emoji ? " wtd-emoji" : "")} aria-hidden="true">
			{foto ? <img src={foto} alt="" loading="lazy" /> : emoji ? <IconoCanal id={c.id} icono={emoji} /> : c.tipo === "canal" ? <WappIcono n={c.anuncios ? "megaphone" : "hash"} /> : c.tipo === "grupo" ? <WappIcono n="users" /> : inicialesDe(c.nombre)}
		</span>
	);
};

// ------------------------------------------------------------------ una ventanita

const ChatVentana: React.FC<{
	campusId: number; yoId: number; v: Ventana; info: EquipoCanal | undefined; version: number; visto: number; movil: boolean;
	onMin: () => void; onCerrar: () => void; onExpandir: () => void; onLeido: () => void;
	/** Para mover todas las ventanitas juntas desde su barra (arrastre.ts). */
	agarre?: React.HTMLAttributes<HTMLElement>;
}> = ({ campusId, yoId, v, info, version, visto, movil, onMin, onCerrar, onExpandir, onLeido, agarre }) => {
	const http = HttpManager.getInstance();
	const [canal, setCanal] = useState<EquipoCanalInfo | null>(null);
	const [mensajes, setMensajes] = useState<EquipoMensaje[]>([]);
	const [hayMas, setHayMas] = useState<boolean>(false);
	const [vistoHasta, setVistoHasta] = useState<number | null>(null);
	const [entregadoHasta, setEntregadoHasta] = useState<number | null>(null);
	const [elegidos, setElegidos] = useState<Elegido[]>([]);
	const [progresoArch, setProgresoArch] = useState<{ i: number; n: number; f: number } | null>(null);
	const [texto, setTexto] = useBorrador("team:" + v.id);   // mismo borrador que la pantalla de WappTeam
	const [respondiendo, setRespondiendo] = useState<EquipoMensaje | null>(null);
	const [reenviando, setReenviando] = useState<EquipoMensaje[] | null>(null);
	// Selección múltiple (2026-10-12): cabeza del mensaje o álbum -> sus mensajes; Copiar y Reenviar como mensajes nuevos.
	const [sel, setSel] = useState<Record<number, EquipoMensaje[]> | null>(null);
	const [reenvioNuevo, setReenvioNuevo] = useState<boolean>(false);
	// Reaccionar desde la ventanita igual que en WappTeam: los 6 de siempre y "+" para el panel completo.
	const [reaccionando, setReaccionando] = useState<number | null>(null);
	const [reacAbajo, setReacAbajo] = useState<boolean>(false);
	const [masReac, setMasReac] = useState<EquipoMensaje | null>(null);
	const elegidosSel = (): EquipoMensaje[] => Object.keys(sel || {}).map(Number).sort((a, b) => a - b).flatMap((k) => (sel || {})[k]);
	const alternarSel = (m: EquipoMensaje, grupo: EquipoMensaje[]) => setSel((prev) => {
		const o = { ...(prev || {}) };
		if (o[m.id]) delete o[m.id]; else o[m.id] = grupo;
		return o;
	});
	const [busy, setBusy] = useState<boolean>(false);
	const [error, setError] = useState<string | null>(null);
	const lista = useRef<HTMLDivElement>(null);
	const caja = useRef<HTMLTextAreaElement>(null);
	useCrecer(caja, texto);
	// @menciones también en la ventanita, con teclado (2026-10-15).
	const men = useMenciones(campusId, v.id);
	const [menciones, setMenciones] = useState<{ id: number; nombre: string }[]>([]);
	const elegirMencion = (p: Persona) => {
		men.poner(caja.current, texto, p, setTexto);
		setMenciones((prev) => (prev.some((x) => x.id === p.id) ? prev : [...prev, { id: p.id, nombre: primerNombre(p) }]));
	};
	// Lupa de la ventanita (como en WappTeam): busca en todo el historial y lleva al mensaje.
	const [buscar, setBuscar] = useState<boolean>(false);
	const [salto, setSalto] = useState<{ id: number; n: number } | null>(null);
	const mensajesRef = useRef<EquipoMensaje[]>(mensajes);
	mensajesRef.current = mensajes;
	const archivo = useRef<HTMLInputElement>(null);

	const alFondo = () => setTimeout(() => { if (lista.current) lista.current.scrollTop = lista.current.scrollHeight; }, 30);
	const cerca = () => !lista.current || lista.current.scrollHeight - lista.current.scrollTop - lista.current.clientHeight < 80;

	// alrededor: de lo más nuevo hasta ese mensaje (buscar). Una recarga normal conserva lo anterior ya cargado.
	const cargar = useCallback(async (antes?: number | null, alrededor?: number | null) => {
		try {
			const pegado = cerca();
			const r = await http.prospectsService.equipoMensajes(campusId, v.id, antes, alrededor);
			const lote = r.data.mensajes;
			const prev = mensajesRef.current;
			const desde = !antes && !alrededor && lote.length ? prev.findIndex((m) => m.id === lote[0].id) : -1;
			setCanal(r.data.canal); setError(null);
			setVistoHasta(r.data.vistoHasta); setEntregadoHasta(r.data.entregadoHasta ?? null);
			if (antes) { setHayMas(r.data.hayMas); setMensajes((p) => [...lote, ...p]); }
			else if (desde > 0) setMensajes([...prev.slice(0, desde), ...lote]);   // hayMas sigue como estaba
			else { setHayMas(r.data.hayMas); setMensajes(lote); }
			if (alrededor) setSalto({ id: alrededor, n: Date.now() });
			else if (!antes && pegado) alFondo();
			if (!antes) onLeido();
		} catch (e) { setError(errorTexto(e)); }
	}, [campusId, v.id]);
	const reaccionar = async (m: EquipoMensaje, emoji: string) => {
		setReaccionando(null);
		try {
			await http.prospectsService.equipoMensajeAccion(campusId, m.id, { accion: "reaccion", emoji });
			cargar();
		} catch (e) { setError(errorTexto(e)); }
	};
	const irACita = useSaltoACita(lista, "data-wtm", mensajes, hayMas, () => cargar(mensajes[0]?.id));
	useEffect(() => {
		if (!salto) return;
		let id = salto.id;
		const al = agruparAlbumes(mensajesRef.current);
		if (al.dentro.has(id)) al.cabeza.forEach((items, cab) => { if (items.some((x) => x.id === salto.id)) id = cab; });
		irACita(id);
	}, [salto?.n]);
	const irAMensaje = (id: number) => {
		if (mensajesRef.current.some((m) => m.id === id)) setSalto({ id, n: Date.now() });
		else cargar(null, id);
	};
	const buscarAqui = useCallback(async (q: string): Promise<ItemBusqueda[]> => {
		const r = await http.prospectsService.equipoBuscar(campusId, q, v.id);
		return r.data.resultados.map((x) => ({ id: x.id, fecha: x.created_at, quien: x.author_name.split(" ")[0], texto: resumenTexto(x.body) || x.file_name || "Archivo" }));
	}, [campusId, v.id]);
	useEffect(() => { if (v.min) setBuscar(false); }, [v.min]);

	// Abierta = a la vista (no avisa) y se lee; minimizada solo enseña cuántos no leídos lleva.
	useEffect(() => {
		if (v.min) return;
		equipoVista.poner(v.id);
		cargar();
		alFondo();
		return () => equipoVista.quitar(v.id);
	}, [v.min, v.id]);
	useEffect(() => { if (!v.min && version) cargar(); }, [version]);
	// Alguien recibió o leyó: solo si cambia alguna palomita mía, y juntando a las que leen casi a la vez.
	const vistoTimer = useRef<any>(null);
	useEffect(() => {
		if (v.min || !visto || !vistoCambiaAlgo(mensajes, yoId, vistoHasta)) return;
		clearTimeout(vistoTimer.current);
		vistoTimer.current = setTimeout(() => cargar(), 1500);
	}, [visto]);
	useEffect(() => () => clearTimeout(vistoTimer.current), []);
	useEffect(() => { if (!v.min && !movil) setTimeout(() => caja.current?.focus(), 60); }, [v.min]);

	// Al instante con relojito, como en la pantalla de WappTeam (equipoEnCamino); los textos salen en fila.
	const enCamino = useEnCamino(v.id, mensajes, yoId);
	const enviar = () => {
		const t = texto.trim();
		if (!t) return;
		const cita = respondiendo;
		const ids = idsMencionados(menciones, t);
		setError(null);
		setTexto(""); setRespondiendo(null); setMenciones([]);
		caja.current?.focus({ preventScroll: true });
		alFondo();
		enCamino.mandar(v.id, t, cita,
			() => http.prospectsService.equipoEnviar(campusId, v.id, t, null, { replyTo: cita?.id || null, menciones: ids }).then((r) => r.data?.id ?? null), {
				ok: () => { cargar(); },
				mal: (e) => { setError(errorTexto(e)); setTexto((antes) => (antes.trim() ? antes : t)); },
			});
	};

	// GIF del buscador: un mensaje con la liga del GIF (se pinta animado).
	const enviarSticker = async (s: Sticker) => {
		setError(null);
		await http.prospectsService.equipoSticker(campusId, v.id, s.id, respondiendo?.id || null);
		setRespondiendo(null);
		await cargar();
		alFondo();
	};
	const enviarGif = async (url: string) => {
		setBusy(true); setError(null);
		try {
			await http.prospectsService.equipoEnviar(campusId, v.id, url, null, { replyTo: respondiendo?.id || null, menciones: [] });
			setRespondiendo(null);
			await cargar();
			alFondo();
		} catch (e) { setError(errorTexto(e)); }
		finally { setBusy(false); }
	};

	// Varios archivos a la vez: elegir, pegar o arrastrar encima de la ventanita → bandeja → se mandan en orden.
	const agregar = (fs: FileList | File[]) => { setError(null); setElegidos((p) => [...p, ...elegidosDe(fs)].slice(0, MAX_ARCHIVOS)); };
	const quitar = (id: string) => setElegidos((p) => { const e = p.find((x) => x.id === id); if (e?.url) URL.revokeObjectURL(e.url); return p.filter((x) => x.id !== id); });
	const cancelarArchivos = () => { elegidos.forEach((e) => e.url && URL.revokeObjectURL(e.url)); setElegidos([]); setProgresoArch(null); };
	const enviarArchivos = async (comentario: string, mencionados: number[]) => {
		const err = await enviarVarios(elegidos, comentario, (f, n, kind, txt, onProgress) =>
			http.prospectsService.equipoArchivoSubir(campusId, v.id, f, n, kind, txt, { replyTo: respondiendo?.id || null, onProgress, menciones: txt ? mencionados : [] }), setProgresoArch);
		setProgresoArch(null);
		if (err) { setError(err); await cargar(); return; }
		cancelarArchivos(); setRespondiendo(null);
		await cargar(); alFondo();
	};
	const zona = useRef<HTMLElement>(null);
	const arrastrando = useArchivosEntrantes(zona, !v.min && !!canal?.puedoEscribir, agregar);

	const nombre = info?.nombre || canal?.nombre || "Conversación";
	const tipo = info?.tipo || canal?.tipo || "directo";
	const noLeidos = info?.no_leidos || 0;
	let ultimoDia = -1;
	let ultimoAutor: number | null = null;
	const albumes = agruparAlbumes(enCamino.vista);

	return (
		<section ref={zona} className={"wtd-ventana" + (v.min ? " min" : "") + (noLeidos && v.min ? " nuevo" : "") + (arrastrando ? " arrastrando" : "")} role="dialog" aria-label={"Conversación con " + nombre}>
			{arrastrando ? <div className="eqm-soltar chico"><WappIcono n="upload" /> Suelta aquí</div> : null}
			<header className="wtd-cab" onClick={v.min ? onMin : undefined} {...(movil ? {} : agarre)}>
				{movil && !v.min ? <button className="wtd-ico" onClick={onCerrar} aria-label="Volver"><WappIcono n="back" /></button> : null}
				<Avatar c={{ id: v.id, tipo, nombre, anuncios: info?.anuncios, otro_id: info?.otro_id, icono: info?.icono }} />
				<button className="wtd-titulo" onClick={(e) => { e.stopPropagation(); if (v.min) onMin(); else onExpandir(); }} title={v.min ? "Abrir" : "Abrir en WappTeam"}>
					<b>{nombre}</b>
					{!v.min && canal && tipo !== "directo" ? <small>{canal.miembros} personas</small> : null}
				</button>
				{noLeidos && v.min ? <span className="wtd-n">{noLeidos > 99 ? "99+" : noLeidos}</span> : null}
				<span className="wtd-cab-acc" onClick={(e) => e.stopPropagation()}>
					{!v.min && canal && !canal.ia && !canal.anuncios && !canal.supervision ? <BotonLlamar campusId={campusId} canalId={v.id} className="wtd-ico" onError={setError} /> : null}
					{!v.min ? <button className={"wtd-ico" + (buscar ? " on" : "")} onClick={() => setBuscar(!buscar)} aria-label="Buscar en esta conversación" title="Buscar" aria-pressed={buscar}><WappIcono n="search" /></button> : null}
					{!movil ? <button className="wtd-ico" onClick={onMin} aria-label={v.min ? "Abrir" : "Minimizar"} title={v.min ? "Abrir" : "Minimizar"}><WappIcono n="minus" /></button> : null}
					{!v.min ? <button className="wtd-ico" onClick={onExpandir} aria-label="Abrir en WappTeam" title="Abrir en WappTeam"><WappIcono n="expand" /></button> : null}
					{!movil ? <button className="wtd-ico" onClick={onCerrar} aria-label="Cerrar" title="Cerrar"><WappIcono n="x" /></button> : null}
				</span>
			</header>
			{v.min ? null : (
				<>
					{canal && tipo !== "directo" ? <LlamadaViva campusId={campusId} llamada={canal.llamada} onError={setError} /> : null}
					{buscar ? <BuscadorChat llave={String(v.id)} pedir={buscarAqui} onIr={irAMensaje} onCerrar={() => setBuscar(false)} /> : null}
					<div className={"wtd-msgs" + (sel ? " eligiendo" : "")} ref={lista} onClick={() => setReaccionando(null)}>
						{hayMas ? <button className="wtd-mas" onClick={() => cargar(mensajes[0]?.id)}>Ver anteriores</button> : null}
						{canal && !enCamino.vista.length ? <div className="wtd-vacio">Todavía no hay mensajes.</div> : null}
						{!canal && !error ? <div className="wtd-vacio">Cargando…</div> : null}
						{enCamino.vista.map((m) => {
							if (albumes.dentro.has(m.id)) return null;
							const album = albumes.cabeza.get(m.id);
							const dia = diaClave(m.created_at);
							const sep = dia !== ultimoDia ? <div className="wtd-dia">{diaEtiqueta(m.created_at)}</div> : null;
							const seguido = dia === ultimoDia && ultimoAutor === m.user_id;
							ultimoDia = dia; ultimoAutor = m.user_id;
							const mio = m.user_id === yoId;
							return (
								<React.Fragment key={m.id}>
									{sep}
									<div data-wtm={m.id} className={"wtd-msg" + (mio ? " mio" : "") + (seguido ? " seguido" : "") + (m.menciones.includes(yoId) ? " menciona" : "") + (esMedio(m, album) ? " con-medio" : "") + (m.file_tipo === "sticker" && !m.deleted_at ? " con-sticker" : "") + (m.reacciones.length ? " con-reac" : "") + (sel && sel[m.id] ? " sel" : "")}
										onClickCapture={sel && !m.deleted_at && !m.enCamino ? (e) => { e.preventDefault(); e.stopPropagation(); alternarSel(m, album || [m]); } : undefined}>
										{!mio && !seguido && tipo !== "directo" ? <span className="wtd-autor">{m.author_name}</span> : null}
										{m.reenviado && !m.deleted_at ? <span className="eq-reenviado"><WappIcono n="forward" />Reenviado</span> : null}
										{m.deleted_at ? <p className="wtd-borrado">Mensaje borrado</p> : (
											<>
												{m.reply_to_id ? <div className="wtd-cita" role="button" tabIndex={0} title="Ir al mensaje" onClick={(e) => { e.stopPropagation(); irACita(m.reply_to_id); }}><b>{m.r_author}</b><span>{resumenTexto(m.r_body) || (m.r_file_tipo ? "Archivo" : "Mensaje")}</span></div> : null}
												{album ? <Album campusId={campusId} items={album} todos={mensajes} /> : m.file_tipo ? <MedioMensaje campusId={campusId} m={m} todos={mensajes} /> : null}
												{m.body ? (esMensajeLlamada(m.body) && !m.deleted_at
													? <BurbujaLlamada campusId={campusId} canalId={v.id} body={m.body} hora={hora(m.created_at)} directo={tipo === "directo"} viva={canal?.llamada} onError={setError} />
													: <Texto t={m.body} />) : null}
												{m.prospect_id ? <span className="wtd-cliente">Cliente compartido: abrir en WappTeam</span> : null}
											</>
										)}
										<span className="wtd-h">{m.edited_at && !m.deleted_at ? "editado · " : ""}{hora(m.created_at)}
									{m.enCamino ? <Reloj /> : mio && !m.importado && !m.deleted_at ? <Palomitas estado={estadoPalomitas(album ? album[album.length - 1] : m, vistoHasta, entregadoHasta)} /> : null}</span>
								<PastillaReacciones reacciones={m.reacciones} onReaccionar={canal && !canal.supervision ? (e) => reaccionar(m, e) : undefined} />
										{!m.deleted_at && !m.enCamino && canal && !canal.supervision ? (
											<span className="wtd-acc-msg" onClick={(e) => e.stopPropagation()}>
												<button className="wtd-responder" onClick={(e) => { setReacAbajo(barraAbajo(e.currentTarget)); setReaccionando(reaccionando === m.id ? null : m.id); }} aria-label="Reaccionar" title="Reaccionar"><WappIcono n="smile" /></button>
												{canal.puedoEscribir ? <button className="wtd-responder" onClick={() => { setRespondiendo(m); caja.current?.focus(); }} aria-label="Responder" title="Responder"><WappIcono n="reply" /></button> : null}
												<button className="wtd-responder" onClick={() => { setReenvioNuevo(false); setReenviando(album || [m]); }} aria-label="Reenviar" title="Reenviar"><WappIcono n="forward" /></button>
												<button className="wtd-responder" onClick={() => setSel({ [m.id]: album || [m] })} aria-label="Seleccionar" title="Seleccionar"><WappIcono n="check" /></button>
											</span>
										) : null}
										{reaccionando === m.id && !m.deleted_at ? (
											<div className={"eq-emojis wtd-emojis" + (reacAbajo ? " abajo" : "")} onClick={(e) => e.stopPropagation()}>{EMOJIS.map((e) => <button key={e} onClick={() => reaccionar(m, e)}>{e}</button>)}
												<button className="eqe-mas" title="Más emojis" aria-label="Más emojis" onClick={() => { setReaccionando(null); setMasReac(m); }}>+</button></div>
										) : null}
									</div>
								</React.Fragment>
							);
						})}
					</div>
					{error ? <div className="wtd-error" role="alert">{error}</div> : null}
					{sel ? (
						<BarraSeleccion compacta n={Object.keys(sel).length} onCancelar={() => setSel(null)}
							texto={() => elegidosSel().map((x) => resumenTexto(x.body)).filter(Boolean).join("\n")}
							onReenviar={() => { const l = elegidosSel(); if (l.length) { setReenvioNuevo(true); setReenviando(l); } }} />
					) : canal && canal.puedoEscribir ? (
						<div className="wtd-escribir">
							{respondiendo ? (
								<div className="wtd-resp"><span><b>Respondiendo a {respondiendo.author_name.split(" ")[0]}</b><small>{resumenTexto(respondiendo.body) || respondiendo.file_name || "Archivo"}</small></span>
									<button className="wtd-ico" onClick={() => setRespondiendo(null)} aria-label="Cancelar respuesta"><WappIcono n="x" /></button></div>
							) : null}
							{elegidos.length ? <BandejaEnvio compacta elegidos={elegidos} onQuitar={quitar} onAgregar={agregar} onCancelar={cancelarArchivos} onEnviar={enviarArchivos} progreso={progresoArch} error={null} mencionar={{ campusId, canalId: v.id }} /> : null}
							<ListaMenciones sugeridas={men.sugeridas} activa={men.activa} onActiva={men.setActiva} onElegir={elegirMencion} />
							<div className="wtd-redactar" style={elegidos.length ? { display: "none" } : undefined}>
								<input ref={archivo} type="file" multiple hidden onChange={(e) => { if (e.target.files) agregar(e.target.files); e.target.value = ""; }} />
								<button className="wtd-ico" onClick={() => archivo.current?.click()} aria-label="Mandar fotos, videos o archivos" title="Fotos, videos o archivos (varios a la vez)"><WappIcono n="clip" /></button>
								<div className="wb-campo compacto">
								<BotonEmoji compacto enBarra onElegir={(em) => insertarEnCursor(caja.current, texto, em, setTexto)} disabled={busy}
									stickers={{ campusId, onEnviar: enviarSticker }} />
								<textarea ref={caja} rows={1} value={texto} placeholder="Escribe un mensaje"
									aria-label={"Mensaje a " + nombre} onChange={(e) => { setTexto(e.target.value); men.revisar(e.target.value, e.target.selectionStart); }}
									onKeyDown={(e) => {
										if (men.tecla(e, elegirMencion)) return;
										teclaEnter(e, enviar);
										if (e.key === "Escape") { if (respondiendo) setRespondiendo(null); else onMin(); }
									}} />
								<BotonGif compacto enBarra campusId={campusId} onElegir={enviarGif} disabled={busy} />
								</div>
								<button className="wtd-enviar" disabled={!texto.trim()} onClick={enviar} onMouseDown={(e) => e.preventDefault()} aria-label="Enviar" title="Enviar"><WappIcono n="send" /></button>
							</div>
						</div>
					) : canal ? <div className="wtd-solo">{canal.supervision ? "Solo lectura (tu equipo)." : "Canal de anuncios: solo las administradoras escriben."}</div> : null}
				</>
			)}
			{reenviando ? <EquipoReenviar campusId={campusId} mensajes={reenviando} nuevo={reenvioNuevo} onCerrar={() => { setReenviando(null); if (reenvioNuevo) setSel(null); }}
				onEnviado={(ids) => { if (ids.includes(v.id)) cargar(); }} /> : null}
			{masReac ? <EmojisFlotante onElegir={(e) => { const m = masReac; setMasReac(null); reaccionar(m, e); }} onCerrar={() => setMasReac(null)} /> : null}
		</section>
	);
};

// ------------------------------------------------------------------ la barrita y los avisos

const WappTeamDock: React.FC = () => {
	const http = HttpManager.getInstance();
	const navigate = useNavigate();
	const location = useLocation();
	const yoId: number | null = useSelector((state: RootState) => (state.rootReducer.sessionState as any).user?.id ?? null);
	const sessionCampus: any = useSelector((state: RootState) => state.rootReducer.sessionState.currentCampus);
	const legacyCampusKey: any = useSelector((state: RootState) => state.currentUserCampus.value);
	const legacyCampusRef: any = useSelector((state: RootState) => state.campusRef.value);
	const legacyCampus: any = legacyCampusKey && legacyCampusRef ? legacyCampusRef[legacyCampusKey] : null;
	const campusId: number | null = legacyCampus?.id ?? sessionCampus?.id ?? null;
	const menuRef: any = useSelector((state: RootState) => (state as any).menuRef?.value);
	// WappTeam se usa con la sección 81 o con la 72 (el back acepta cualquiera de las dos).
	const permitido = !!(menuRef && (menuRef.wappteam || menuRef.wappchat));
	const enWappTeam = location.pathname.startsWith("/wappteam");
	const oculto = enWappTeam || location.pathname.startsWith("/access");

	const [ancho, setAncho] = useState<number>(() => window.innerWidth);
	useEffect(() => { const f = () => setAncho(window.innerWidth); window.addEventListener("resize", f); return () => window.removeEventListener("resize", f); }, []);
	const movil = ancho <= MOVIL;
	const maxVentanas = movil ? 1 : Math.max(1, Math.min(3, Math.floor((ancho - 16 - ANCHO_BARRA) / (ANCHO_VENTANA + HUECO))));

	// No tapar la caja de escribir de WappChat/CRM (y lo que se marque con data-evitar-dock): si hay una pegada abajo a la
	// derecha, todo el dock se sube encima de ella.
	const [subir, setSubir] = useState<number>(0);
	// Se mueve arrastrando la barra o el encabezado de una ventanita (doble clic: de vuelta a su lugar).
	const arrastre = useArrastre("wtd");
	useEffect(() => {
		if (movil) { setSubir(0); return; }
		const medir = () => {
			const vw = window.innerWidth;
			const vh = window.innerHeight;
			let h = 0;
			document.querySelectorAll(".cv-compositor, [data-evitar-dock]").forEach((el) => {
				const r = el.getBoundingClientRect();
				if (r.width && r.height && r.right > vw - ANCHO_BARRA && r.bottom >= vh - 12 && r.top > vh / 3) h = Math.max(h, vh - r.top);
			});
			setSubir((prev) => (Math.abs(prev - h) > 2 ? Math.round(h) : prev));
		};
		medir();
		const t = setInterval(medir, 300);
		return () => clearInterval(t);
	}, [movil, location.pathname]);

	const [canales, setCanales] = useState<EquipoCanal[]>([]);
	const canalesRef = useRef<EquipoCanal[]>([]);
	canalesRef.current = canales;
	// El total sale de la lista (misma regla que el servidor: silenciadas solo si la mencionan) y alimenta el globito de arriba.
	const noLeidos = canales.reduce((s, c) => s + (c.no_leidos || 0), 0);
	const noLeidosRef = useRef<number>(0);
	noLeidosRef.current = noLeidos;
	const cargados = useRef<boolean>(false);
	const [abierta, setAbierta] = useState<boolean>(false);
	// Minimizada a un circulito (Esteban, 2026-10-13: "no vi que tenía para minimizar"): solo el ícono y los no leídos.
	const [circulo, setCirculoSt] = useState<boolean>(() => { try { return localStorage.getItem("wtd.circulo") === "1"; } catch { return false; } });
	const setCirculo = (v: boolean) => { setCirculoSt(v); try { localStorage.setItem("wtd.circulo", v ? "1" : "0"); } catch { /* sin almacenamiento */ } };
	const [busca, setBusca] = useState<string>("");
	const llaveIa = "wteam.avisosIa." + (yoId || 0);
	const [toasts, setToasts] = useState<Toast[]>(() => {
		try { return yoId ? (JSON.parse(localStorage.getItem(llaveIa) || "[]") as Toast[]).filter((t) => t && t.ia && t.canalId) : []; } catch { return []; }
	});
	useEffect(() => {
		if (!yoId) return;
		try { localStorage.setItem(llaveIa, JSON.stringify(toasts.filter((t) => t.ia).slice(0, MAX_IA_GUARDADOS))); } catch { /* sin almacenamiento */ }
	}, [toasts, llaveIa]);
	const [versiones, setVersiones] = useState<{ [id: number]: number }>({});
	const [vistos, setVistos] = useState<{ [id: number]: number }>({});
	const [permiso, setPermiso] = useState<string>(() => permisoAvisos());
	const [sonido, setSonido] = useState<boolean>(() => prefs.sonido);
	const [noMolestar, setNoMolestar] = useState<boolean>(() => prefs.noMolestar);
	const [ofrecer, setOfrecer] = useState<boolean>(() => !prefs.avisoDescartado);

	// Ventanas abiertas: se recuerdan por persona en esta computadora.
	const llave = "wteam.ventanas." + (yoId || 0);
	const leerVentanas = (k: string): Ventana[] => {
		// En el celular una ventana abierta tapa toda la pantalla: al volver a entrar se recuerdan minimizadas.
		try { return (JSON.parse(localStorage.getItem(k) || "[]") as Ventana[]).filter((x) => x && x.id).slice(0, 3).map((x) => (window.innerWidth <= MOVIL ? { ...x, min: true } : x)); } catch { return []; }
	};
	const [ventanas, setVentanas] = useState<Ventana[]>(() => (yoId ? leerVentanas(llave) : []));
	const llaveCargada = useRef<string | null>(yoId ? llave : null);
	useEffect(() => {
		if (!yoId || llaveCargada.current === llave) return;
		llaveCargada.current = llave;
		setVentanas(leerVentanas(llave));
	}, [llave]);
	useEffect(() => {
		// Solo se guarda lo de la persona ya cargada (si no, un arranque en blanco borraría lo recordado).
		if (yoId && llaveCargada.current === llave) { try { localStorage.setItem(llave, JSON.stringify(ventanas)); } catch { /* */ } }
	}, [ventanas]);

	const cargarCanales = useCallback(async () => {
		if (!campusId) return;
		try {
			const r = await http.prospectsService.equipoCanales(campusId);
			setCanales(r.data.canales); cargados.current = true;
			const ia = r.data.canales.find((c) => c.fijo);
			if (ia && !ia.no_leidos) setToasts((t) => (t.some((x) => x.ia && x.canalId === ia.id) ? t.filter((x) => !(x.ia && x.canalId === ia.id)) : t));
		} catch { /* sin WappTeam o sin red: la barrita se queda como estaba */ }
	}, [campusId]);
	const temporizador = useRef<any>(null);
	// Un mensaje en un canal grande avisa a cientos de pestañas a la vez: cada una pide la lista en un momento distinto
	// (1.2-2.7 s), y el aviso y el cambio del globito que llega detrás se juntan en una sola carga (12-oct-2026, hora pico).
	const recargar = useCallback(() => {
		clearTimeout(temporizador.current);
		temporizador.current = setTimeout(cargarCanales, 1200 + Math.round(Math.random() * 1500));
	}, [cargarCanales]);

	// El buscador también encuentra personas para escribirles aunque no haya conversación (2026-10-13).
	const [gente, setGente] = useState<{ id: number; nombre: string; rol: string | null }[]>([]);
	useEffect(() => {
		const q = busca.trim();
		if (q.length < 2 || !campusId) { setGente([]); return; }
		const t = setTimeout(() => http.prospectsService.equipoPersonas(campusId, q, null, null, campusId)
			.then((r) => setGente(r.data.personas.filter((p) => p.id !== yoId).slice(0, 6))).catch(() => setGente([])), 300);
		return () => clearTimeout(t);
	}, [busca, campusId]);
	const escribirA = async (userId: number) => {
		if (!campusId) return;
		try { const r = await http.prospectsService.equipoDirecto(campusId, userId); setBusca(""); abrir(r.data.id); recargar(); } catch { /* sin permiso o sin red */ }
	};

	const abrir = useCallback((id: number) => {
		setToasts((t) => t.filter((x) => x.canalId !== id));
		// En el celular la conversación va a la pantalla de WappTeam: la ventanita a pantalla completa no se acomoda al
		// teclado del iPhone (la caja de escribir quedaba tapada abajo y todo brincaba al enfocarla; Esteban, 2026-10-10).
		if (window.location.pathname.startsWith("/wappteam") || window.innerWidth <= MOVIL) { setAbierta(false); navigate("/wappteam?c=" + id); return; }
		setVentanas((prev) => {
			const resto = prev.filter((x) => x.id !== id);
			return [{ id, min: false }, ...resto].slice(0, 3);
		});
		if (movil) setAbierta(false);
	}, [maxVentanas, movil]);

	// La lista se cierra al hacer clic fuera de ella (en computadora).
	const barraRef = useRef<HTMLDivElement>(null);
	useEffect(() => {
		if (!abierta || movil) return;
		const f = (e: MouseEvent) => { if (barraRef.current && !barraRef.current.contains(e.target as Node)) setAbierta(false); };
		document.addEventListener("mousedown", f);
		return () => document.removeEventListener("mousedown", f);
	}, [abierta, movil]);

	// Conexión al instante mientras haya sesión (la comparte con WappChat y WappTeam).
	useEffect(() => (permitido && campusId ? push.usar(campusId) : undefined), [permitido, campusId]);
	useEffect(() => {
		if (!permitido || !campusId) return;
		cargarCanales();
		let t: any;
		const ciclo = () => { t = setTimeout(() => { if (document.visibilityState === "visible") cargarCanales(); ciclo(); }, Math.max(60000, intervaloRespaldo())); };
		ciclo();
		return () => clearTimeout(t);
	}, [permitido, campusId, cargarCanales]);

	const totalTeam = useContadores().wappteam;
	// Lo que cuenta el dock manda al globito; si el servidor (respaldo de contadores, o al leer) dice más, se pide la lista.
	useEffect(() => { if (permitido && campusId && cargados.current) ponerWappteam(noLeidos); }, [noLeidos, permitido, campusId]);
	useEffect(() => () => ponerWappteam(null), []);
	// Solo si el servidor trae MÁS que lo mío (menos = ya lo leí aquí) y a lo más una vez cada 10 s (16-oct-2026, dieta de
	// peticiones). Las ediciones y reacciones ("cambio") recargan aparte, como siempre.
	const totalTeamRef = useRef<number>(0);
	totalTeamRef.current = totalTeam;
	const difT = useRef<any>(null);
	const difUltima = useRef<number>(0);
	useEffect(() => {
		if (!permitido || !campusId || !cargados.current || totalTeam <= noLeidosRef.current || difT.current) return;
		difT.current = setTimeout(() => {
			difT.current = null;
			if (totalTeamRef.current <= noLeidosRef.current) return;
			difUltima.current = Date.now();
			recargar();
		}, Math.max(0, 10000 - (Date.now() - difUltima.current)));
	}, [totalTeam]);
	useEffect(() => () => clearTimeout(difT.current), []);

	const avisar = useCallback((d: any) => {
		const cid = Number(d?.c);
		if (!cid || !d?.de || Number(d?.u) === yoId) return;
		// Mensaje que es un aviso del Centro de Avisos: lo enseña AvisosEnVivo (tarjeta + notificación con el tag del aviso).
		if (Number(d?.aviso) > 0) return;
		const mencion = Array.isArray(d?.menciones) && !!yoId && d.menciones.includes(yoId);
		const c = canalesRef.current.find((x) => x.id === cid);
		if ((prefs.noMolestar || c?.silenciado) && !mencion) return;
		if (equipoVista.viendo(cid)) return;
		const donde = c && c.tipo !== "directo" ? " en " + c.nombre : "";
		const titulo = (mencion ? "Te mencionó " : "") + d.de + donde;
		const cuerpo = String(d.texto || "");
		if (Number(d?.ia) === 1 || c?.fijo) {
			// IA Washington: cada aviso se queda (se apilan) hasta cerrarlo o abrir la conversación. Con la pestaña atrás
			// también sale el del sistema, y la tarjeta la espera al volver.
			if (document.visibilityState !== "visible" && permisoAvisos() === "granted") avisoLocal(titulo, cuerpo, "equipo-" + cid, "/wappteam?c=" + cid);
			const key = Date.now() + Math.random();
			setToasts((t) => [{ key, canalId: cid, titulo, texto: cuerpo, mencion, ia: true }, ...t].slice(0, MAX_IA_GUARDADOS + MAX_TOASTS));
			sonar();
			return;
		}
		if (document.visibilityState !== "visible" && permisoAvisos() === "granted") {
			avisoLocal(titulo, cuerpo, "equipo-" + cid, "/wappteam?c=" + cid);   // mismo tag que el push del celular: si llegan los dos, queda uno
		} else {
			// Pestaña al frente, o sin permiso del navegador: la tarjetita (si la pestaña está atrás, la ve al volver).
			const key = Date.now() + Math.random();
			setToasts((t) => [{ key, canalId: cid, titulo, texto: cuerpo, mencion }, ...t.filter((x) => x.ia || x.canalId !== cid)]);
			const quitar = () => setTimeout(() => setToasts((t) => t.filter((x) => x.key !== key)), 7000);
			if (document.visibilityState === "visible") quitar();
			else document.addEventListener("visibilitychange", function una() { if (document.visibilityState === "visible") { document.removeEventListener("visibilitychange", una); quitar(); } });
		}
		sonar();
	}, [yoId, abrir]);

	useEffect(() => {
		if (!permitido) return;
		const offVisto = push.on("equipo_visto", (d) => { const cid = Number(d?.c); if (cid) setVistos((v) => ({ ...v, [cid]: (v[cid] || 0) + 1 })); });
		const off = push.on("equipo", (d) => {
			const cid = Number(d?.c);
			if (cid) setVersiones((v) => ({ ...v, [cid]: (v[cid] || 0) + 1 }));
			if (!d?.cambio) avisar(d);
			// Mensaje nuevo: la fila se pinta con lo que trae el aviso, sin pedir la lista (14-oct-2026: cada mensaje en un
			// canal grande pedía la lista y los globitos en cientos de pestañas a la vez). Ediciones, reacciones y canales
			// que todavía no tengo: la lista de siempre.
			if (!cid || d?.cambio || !d?.de || !canalesRef.current.some((x) => x.id === cid)) { recargar(); return; }
			const mio = Number(d.u) === yoId;
			const viendo = equipoVista.viendo(cid);
			const mencion = Array.isArray(d.menciones) && !!yoId && d.menciones.includes(yoId);
			setCanales((cs) => {
				const i = cs.findIndex((x) => x.id === cid);
				if (i < 0) return cs;
				const c = cs[i];
				const cuenta = !mio && !viendo && (!c.silenciado || mencion || c.menciones > 0);
				const n: EquipoCanal = { ...c, ultimo: `${d.de}||${String(d.texto || "")}`, last_message_at: new Date().toISOString(),
					no_leidos: cuenta ? (c.no_leidos || 0) + 1 : c.no_leidos, menciones: mencion && !mio && !viendo ? (c.menciones || 0) + 1 : c.menciones };
				const resto = cs.filter((_, j) => j !== i);
				// Mismo orden que el servidor: IA fija, las que fijé yo, anuncios fijados, y luego lo más reciente arriba.
				const grupo = (x: EquipoCanal) => (x.fijo ? 0 : x.fijada ? 1 : x.anuncioFijo ? 2 : 3);
				const k = resto.filter((x) => grupo(x) < grupo(n)).length;
				return [...resto.slice(0, k), n, ...resto.slice(k)];
			});
		});
		return () => { off(); offVisto(); };
	}, [permitido, recargar, avisar]);

	if (!permitido || !campusId || !yoId) return null;

	const aLaVistaT = toasts.slice(0, MAX_TOASTS);
	const ocultos = toasts.slice(MAX_TOASTS);
	const toastsUI = toasts.length ? (
		<div className={"wtd-toasts" + (oculto ? " solo" : "") + (abierta && !movil ? " con-lista" : "")} aria-live="polite" style={subir ? { bottom: subir + 56 } : undefined}>
			{aLaVistaT.map((t) => (
				<div key={t.key} className={"wtd-toast" + (t.mencion ? " mencion" : "") + (t.ia ? " ia" : "")} role="status">
					<button className="wtd-toast-cuerpo" onClick={() => abrir(t.canalId)}>
						<span className="wtd-toast-ico"><WappIcono n={t.mencion ? "bell" : t.ia ? "fijar" : "message"} /></span>
						<span><b>{t.titulo}</b><small>{t.texto}</small></span>
					</button>
					<button className="wtd-ico" onClick={() => setToasts((x) => x.filter((y) => y.key !== t.key))} aria-label="Cerrar aviso"><WappIcono n="x" /></button>
				</div>
			))}
			{ocultos.length ? (
				<div className="wtd-toast-mas">
					<button className="wtd-toast-mas-ver" onClick={() => abrir(ocultos[0].canalId)}>y {ocultos.length} más</button>
					<button className="wtd-toast-mas-ver" onClick={() => setToasts([])}>Cerrar Todos</button>
				</div>
			) : null}
		</div>
	) : null;
	// En el celular no va la barrita de abajo (tapaba botones; Esteban, 2026-10-10): WappTeam queda en el ícono de arriba y
	// aquí solo los avisos.
	if (oculto || movil) return toastsUI;

	const q = busca.trim().toLowerCase();
	const recientes = canales.filter((c) => !q || c.nombre.toLowerCase().includes(q)).slice(0, q ? 40 : 25);
	// Las que caben a lo ancho (3 en computadora, 1 en el celular); las demás se quedan recordadas.
	const visibles = ventanas.filter((v) => canales.length === 0 || canales.some((c) => c.id === v.id)).slice(0, maxVentanas);

	return (
		<>
			{toastsUI}
			<div ref={arrastre.ref} className={"wtd" + (movil ? " movil" : "") + (abierta ? " con-lista" : "") + (subir && !arrastre.movida ? " arriba" : "") + (arrastre.movida ? " movida" : "")}
				style={{ ...(subir && !arrastre.movida ? ({ bottom: subir + 8, "--wtd-subir": subir + 8 + "px" } as any) : {}), ...arrastre.style }}>
				{circulo && !abierta ? (
					<button className="wtd-circulo" ref={barraRef as any} onClick={() => setAbierta(true)} {...arrastre.agarre}
						title="WappTeam · clic para abrir · arrastra para moverlo" aria-label={"WappTeam" + (noLeidos ? ", " + noLeidos + " sin leer" : "")}>
						<WappIcono n="message" />
						{noLeidos ? <span className="wtd-n">{noLeidos > 99 ? "99+" : noLeidos}</span> : null}
					</button>
				) : (
				<div className={"wtd-barra" + (abierta ? " abierta" : "")} ref={barraRef}>
					<button type="button" className="wtd-minimizar" onClick={() => { setCirculo(!circulo); setAbierta(false); }}
						title={circulo ? "Dejar la barra completa" : "Minimizar a un circulito"} aria-label={circulo ? "Dejar la barra completa" : "Minimizar"}>
						<WappIcono n={circulo ? "expand" : "minus"} /></button>
					<button className="wtd-barra-cab" onClick={() => setAbierta(!abierta)} aria-expanded={abierta} {...arrastre.agarre} title="Clic para abrir · arrastra para moverla · doble clic la regresa" aria-label={"WappTeam" + (noLeidos ? ", " + noLeidos + " sin leer" : "")}>
						<span className="wtd-agarre" aria-hidden="true">⠿</span>
						<WappIcono n="message" />
						<b>WappTeam</b>
						{noLeidos ? <span className="wtd-n">{noLeidos > 99 ? "99+" : noLeidos}</span> : null}
						{noMolestar ? <span className="wtd-dnd" title="No molestar"><WappIcono n="bellOff" /></span> : null}
						{abierta ? <span className="wtd-cerrar-lista" aria-hidden="true"><WappIcono n="x" /></span> : null}
					</button>
					{abierta ? (
						<div className="wtd-lista">
							{ofrecer && permiso === "default" ? (
								<div className="wtd-ofrecer">
									<span>¿Te avisamos de los mensajes nuevos aunque estés en otra pestaña?</span>
									<span className="wtd-ofrecer-acc">
										<button className="wtd-btn pri" onClick={async () => setPermiso(await pedirPermisoAvisos())}>Activar avisos</button>
										<button className="wtd-btn" onClick={() => { prefs.avisoDescartado = true; setOfrecer(false); }}>Ahora no</button>
									</span>
								</div>
							) : null}
							<input type="search" value={busca} onChange={(e) => setBusca(e.target.value)} placeholder="Buscar persona o conversación" aria-label="Buscar persona o conversación" />
							<div className="wtd-filas">
								{recientes.map((c) => (
									<button key={c.id} className={"wtd-fila" + (c.no_leidos ? " nuevo" : "")} onClick={() => abrir(c.id)}>
										<Avatar c={c} />
										<span className="wtd-fila-cuerpo">
											<span className="l1"><b>{c.nombre}</b>{c.fijo || c.fijada ? <span className="wtd-fijo" aria-label="Fija arriba"><WappIcono n="fijar" /></span> : null}<small>{c.last_message_at ? cuando(c.last_message_at) : ""}</small></span>
											<span className="l2"><span>{previa(c)}</span>
												{c.menciones ? <span className="wtd-n oro">@</span> : null}
												{c.no_leidos ? <span className="wtd-n">{c.no_leidos}</span> : null}</span>
										</span>
									</button>
								))}
								{(() => {
									const ya = new Set(recientes.filter((c) => c.tipo === "directo").map((c) => c.otro_id));
									const nuevas = gente.filter((p) => !ya.has(p.id));
									return nuevas.length ? (
										<>
											<div className="wtd-dia">Personas</div>
											{nuevas.map((p) => (
												<button key={"p" + p.id} className="wtd-fila" onClick={() => escribirA(p.id)}>
													<Avatar c={{ id: p.id, tipo: "directo", nombre: p.nombre, otro_id: p.id }} />
													<span className="wtd-fila-cuerpo"><span className="l1"><b>{p.nombre}</b><small>Escribirle</small></span><span className="l2"><span>{p.rol || ""}</span></span></span>
												</button>
											))}
										</>
									) : null;
								})()}
								{!recientes.length && !gente.length ? <div className="wtd-vacio">{q ? "Nada con ese nombre." : "Sin conversaciones todavía."}</div> : null}
							</div>
							<div className="wtd-pie">
								<button className="wtd-btn pri" onClick={() => { setAbierta(false); navigate("/wappteam"); }}>Abrir WappTeam</button>
								<button className={"wtd-ico" + (sonido ? " on" : "")} aria-pressed={sonido} title={sonido ? "Sonido encendido" : "Sonido apagado"}
									onClick={() => { prefs.sonido = !sonido; setSonido(!sonido); }}><WappIcono n={sonido ? "volume" : "volumeOff"} /></button>
								<button className={"wtd-ico" + (noMolestar ? " on" : "")} aria-pressed={noMolestar} title={noMolestar ? "No molestar: encendido (solo te avisa si te mencionan)" : "No molestar"}
									onClick={() => { prefs.noMolestar = !noMolestar; setNoMolestar(!noMolestar); }}><WappIcono n={noMolestar ? "bellOff" : "bell"} /></button>
							</div>
						</div>
					) : null}
				</div>
				)}
				{visibles.map((v) => (
					<ChatVentana key={v.id} campusId={campusId} yoId={yoId} v={v} info={canales.find((c) => c.id === v.id)} version={versiones[v.id] || 0} visto={vistos[v.id] || 0} movil={movil}
						onMin={() => setVentanas((p) => p.map((x) => (x.id === v.id ? { ...x, min: !x.min } : x)))}
						onCerrar={() => setVentanas((p) => p.filter((x) => x.id !== v.id))}
						onLeido={recargar} agarre={arrastre.agarre}
						onExpandir={() => { setVentanas((p) => p.filter((x) => x.id !== v.id)); navigate("/wappteam?c=" + v.id); }} />
				))}
			</div>
		</>
	);
};

export default WappTeamDock;
